import { ContentReferenceType } from "../../../../common/types/ContentReferenceType";
import {
    ContentAssociationAncillaryDetails,
    ContentAssociationDetails,
    ContentAssociationMovieDetails,
    ContentAssociationTvSeriesDetails
} from "../types/ContentAssociationDetails";
import { ContentAssociationFormState } from "../types/ContentAssociationFormState";

export const inactiveContentMessage = "Archived or deleted content is selected.";

export const checkIsInactiveContentSelected = (
    fetchedContent?: ContentAssociationDetails,
    selectedContent?: ContentAssociationFormState
): boolean => {
    if (!fetchedContent || !selectedContent) return false;

    switch (fetchedContent.type) {
        case ContentReferenceType.Movie:
            return isMovieContentArchivedOrDeleted(fetchedContent, selectedContent);
        case ContentReferenceType.TvSeries:
            return isTvSeriesContentArchivedOrDeleted(fetchedContent, selectedContent);
        case ContentReferenceType.Ancillary:
            return isAncillaryContentArchivedOrDeleted(fetchedContent);
        default:
            return false;
    }
};

const isMovieContentArchivedOrDeleted = (
    fetchedContent: ContentAssociationMovieDetails,
    selectedContent: ContentAssociationFormState
) => {
    return (
        fetchedContent.buzz?.isArchived ||
        fetchedContent.buzz?.isDeleted ||
        hasArchivedSelectedVersion(fetchedContent.versions, selectedContent)
    );
};

const isAncillaryContentArchivedOrDeleted = (fetchedContent: ContentAssociationAncillaryDetails) => {
    return (fetchedContent.buzz?.isArchived || fetchedContent.buzz?.isDeleted) ?? false;
};

const isTvSeriesContentArchivedOrDeleted = (
    fetchedContent: ContentAssociationTvSeriesDetails,
    selectedContent: ContentAssociationFormState
) => {
    const episode = getEpisode(fetchedContent, selectedContent);

    return (
        episode?.buzz?.isArchived ||
        episode?.buzz?.isDeleted ||
        hasArchivedSelectedVersion(episode?.versions ?? [], selectedContent)
    );
};

const hasArchivedSelectedVersion = (
    versions: { id: string; buzzVersion?: { isArchived?: boolean } }[],
    selectedContent: ContentAssociationFormState
) => {
    return versions.some((v) => v.buzzVersion?.isArchived && includesVersion(selectedContent, v.id));
};

const getEpisode = (content: ContentAssociationTvSeriesDetails, selectedContent: ContentAssociationFormState) => {
    const season = content.seasons?.find((s) => s.id === selectedContent.seasonId);

    return season?.episodes.find((e) => e.id === selectedContent.episodeId);
};

const includesVersion = (selectedContent: ContentAssociationFormState, versionId: string): boolean => {
    return selectedContent.versionIds?.some((id) => id === versionId) ?? false;
};
